var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:{
    [`${_setup.type}`]: !!_setup.type,
    [`${_setup.size}`]: !!_setup.size,
}},[(_setup.size === 'l')?[_vm._t("default",function(){return [_vm._v("\n            "+_vm._s(_setup.text)+"\n        ")]})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }